import { sendRequest } from '../../config';

export interface dataStudyId {
    studyid: string;
    status: string;
}

export const getStudyId = async (): Promise<dataStudyId> => {
    const ENDPOINT = 'v2/signosvitales/studyId';
    return sendRequest({
        method: 'get',
        path: ENDPOINT,
        withCredentials: true,
        skipAuth: true,
    });
};